import { LAYOUT, nodeWidth, isValueNode, type GraphNode } from '../graph/nodeDefs.js';
import { RENDER_NODE_DEFS } from '../graph/renderNodeDefs.js';
import { EVENT_NODE_DEFS } from '../graph/eventNodeDefs.js';
import { getDataNodeDefs } from '../graph/dataNodeDefs.js';
import { pan } from './viewportState.js';
import { getEl, getSocketEl } from '../dom.js';

export function getDotWorldPosFor(
  nodes: GraphNode[],
  nodeId: string,
  portIdx: number,
  isOut: boolean,
): { x: number; y: number } {
  const dotEl = getSocketEl(nodeId, portIdx, isOut ? 'out' : 'in');
  if (dotEl) {
    const wrapper = getEl('graph-canvas-wrapper');
    const wrapperRect = wrapper.getBoundingClientRect();
    const dotRect = dotEl.getBoundingClientRect();
    return {
      x: (dotRect.left + dotRect.width / 2 - wrapperRect.left) / pan.scale,
      y: (dotRect.top + dotRect.height / 2 - wrapperRect.top) / pan.scale
    };
  }

  const defs = { ...RENDER_NODE_DEFS, ...getDataNodeDefs(), ...EVENT_NODE_DEFS };
  const node = nodes.find(item => item.id === nodeId);
  if (!node) return { x: 0, y: 0 };
  const def = defs[node.type];
  let portRow = 0;

  // An uncatalogued node's sockets exist only in the DOM, found above.
  if (!def) return { x: node.x, y: node.y + LAYOUT.HDR };
  if (isValueNode(node)) {
    portRow = 0;
  } else {
    const inputs = typeof def!.inputs === 'function' ? def!.inputs(node) : def!.inputs;
    portRow = isOut ? inputs.length + portIdx : portIdx;
  }

  const dotY = node.y + LAYOUT.HDR + LAYOUT.PAD + portRow * LAYOUT.ROW + LAYOUT.ROW / 2;
  const dotX = isOut ? node.x + nodeWidth(node, defs) : node.x;
  return { x: dotX, y: dotY };
}
